module.exports = __webpack_public_path__ + "img/project-cover8.625b8698.png";